import React, { useState, useRef, useEffect } from "react";
import { SketchPicker } from 'react-color';
import { isSet } from '../../../../Utils/CommonFunctions';

const Color = (props) => {
  const {path,keyParam,value,elementData } = props;
  //console.log('elementData===',elementData)
  const colorValue = isSet(elementData,null)!==null?isSet(elementData.attributes.style[props.keyParam],null)!==null?elementData.attributes.style[props.keyParam]:'#000000':'#000000';
  const [showPicker, setShowPicker] = useState(false);
  const colorPickerRef = useRef(null);

  const handleDocumentClick = (event) => {
    if (colorPickerRef.current && !colorPickerRef.current.contains(event.target)) {
        setShowPicker(false);
        // console.log('sss');
    }
  };

  useEffect(() => {
    if(showPicker===true){
        document.addEventListener('click', handleDocumentClick);
    }
   

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [showPicker]);

  const handleChangeComplete = (colorval) => {
    // console.log('colorval',colorval);
    props.changeHandler(path,keyParam,colorval.hex);
    // setColor(newColor.hex);
  };

  const handleIconClick = () => {
    setShowPicker(!showPicker);
  };

  return (
    <div style={{ position: 'relative' }}>
      <span
        onClick={handleIconClick}
        className="colorinput-color"
        style={{ cursor: 'pointer', backgroundColor: colorValue, zIndex: showPicker ? 1 : 'auto' }}
      ></span>
      {showPicker && (
        <div
          className="color-pallet-modal"
          style={{
            position: 'absolute',
            top: '40px',
            right: '0',
            zIndex: 99999,
          }}
          ref={colorPickerRef}
        >
          <SketchPicker color={colorValue} onChangeComplete={handleChangeComplete} />
        </div>
      )}
    </div>
  );
};

Color.defaultProps = {
    value: '#000000',
    colorValue: '#000000'
};

export default Color;
